<template>
  <li :class="classList">
    <slot></slot>
  </li>
</template>
<style>
.navbar .navbar-nav li > a.active,
.navbar .navbar-nav li > a.active > i.menu-icon,
.navbar .navbar-nav li > a.open,
.navbar .navbar-nav li > a.open > i.menu-icon {
  color: #fff !important;
}
.navbar .navbar-nav li.menu-item-has-children.show > a,
.navbar .navbar-nav li.menu-item-has-children.show > a i.menu-icon,
.navbar .navbar-nav li.menu-item-has-children.show > ul.sub-menu li.nav-item > a i.menu-icon
.navbar .navbar-nav li.menu-item-has-children.show > ul.sub-menu li.nav-item > a .menu-title-text {
  color: #fff !important;
}
</style>
<script>
export default {
  name: "sidebar-nav-item",
  props: {
    classes: {
      type: String,
      default: ""
    }
  },
  computed: {
    classList() {
      return [
        "nav-item",
        ...this.itemClasses // pull them all properties and create a key value pair
      ];
    },
    itemClasses() {
      return this.classes ? this.classes.split(" ") : "";
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/sidebar/SidebarNavItem.vue